import { render, staticRenderFns } from "./areaClientiButton.vue?vue&type=template&id=0111bc1b&"
import script from "./areaClientiButton.vue?vue&type=script&lang=js&"
export * from "./areaClientiButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports